import { Phone, FileText } from "lucide-react";

const MobileCTA = () => {
  return (
    <div className="md:hidden sticky-cta-mobile" data-testid="mobile-cta">
      <div className="flex gap-3">
        <a
          href="tel:+15202007739,2"
          className="flex-1 flex items-center justify-center gap-2 bg-[#FF4D00] text-white py-3 font-heading font-bold uppercase text-sm tracking-wide"
          data-testid="mobile-call-btn"
        >
          <Phone className="w-4 h-4" />
          Call Now
        </a>
        <a
          href="#quote"
          className="flex-1 flex items-center justify-center gap-2 bg-white text-[#1A1A1A] py-3 font-heading font-bold uppercase text-sm tracking-wide border-2 border-white"
          data-testid="mobile-quote-btn"
        >
          <FileText className="w-4 h-4" />
          Free Quote
        </a>
      </div>
    </div>
  );
};

export default MobileCTA;
